import moment from 'moment'

export * from './animateScroll'
export * from './analytics'

export const cookieStorage = {
    getItem: (item: string): string => {
        const cookies: { [key: string]: string } = document.cookie
            .split(';')
            .map((cookie) => cookie.split('='))
            .reduce(
                (acc, [key, value]) => ({ ...acc, [key.trim()]: value }),
                {}
            )
        return cookies[item]
    },
    setItem: (
        item: string,
        value: string | boolean,
        expirationDate?: Date
    ): void => {
        document.cookie = `${item}=${value}; path=/;${
            expirationDate ? ` expires=${expirationDate.toUTCString()}` : ''
        }`
    },
    deleteItem: (item: string): void => {
        document.cookie = `${item} + =; Max-Age=-99999999;`
    },
}

const setWindowHeight = () => {
    const windowHeight = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${windowHeight}px`)
}

window.addEventListener('load', () => {
    setWindowHeight()
})

window.addEventListener('resize', () => {
    setWindowHeight()
})

export const openModalActions = () => {
    document.documentElement.classList.add('-modal-open')
}

export const closeModalActions = (hasRouteChange: boolean) => {
    document.documentElement.classList.remove('-modal-open')
    window.history.replaceState({}, document.title, window.location.pathname)
    !hasRouteChange && window.history.back()
}

export const toggleBodyScroll = () => {
    document.documentElement.classList.toggle('-modal-open')
}

export const formatPrice = (value: number, hasCurrency?: boolean) => {
    const price = value / 100
    const formattedPrice = price
        .toFixed(price % 1 > 0 ? 2 : 0)
        .replace('.', ',')

    return `${formattedPrice}${hasCurrency ? ' PLN' : ''}`
}

/**
 * Returns index of later time or -1 in case they are equal.
 *
 * @param {string} time1 Time in format HH:MM.
 * @param {string} time2 Time in format HH:MM.
 * @return {number} -1 || 0 || 1.
 */
export const getLaterTime = (time1: string, time2: string) => {
    const [hours1, minutes1] = time1.split(':')
    const [hours2, minutes2] = time2.split(':')

    const date1 = new Date(2022, 0, 1, +hours1, +minutes1)
    const date2 = new Date(2022, 0, 1, +hours2, +minutes2)

    if (date1.getTime() > date2.getTime()) return 0
    else if (date2.getTime() > date1.getTime()) return 1
    else return -1
}

// dates

export const sortDates = (dates: string[]) =>
    dates.sort(
        (previous, next) =>
            new Date(previous).getTime() - new Date(next).getTime()
    )

// formatted dates

interface GetExpiryDateProps {
    length: number
    unit: moment.unitOfTime.DurationConstructor
}
export const getExpiryDate = ({ length, unit }: GetExpiryDateProps) =>
    moment().add(length, unit).format('DD.MM.YYYY')

// text

export const capitalize = (text: string) => {
    const firstLetter = text.charAt(0).toUpperCase()
    return firstLetter + text.slice(1)
}

// misc

export const removeTrailingSlashFromPathName = (pathname: string) => {
    const regex = new RegExp('/$')

    const hasTrailingSlash = regex.test(pathname)

    if (pathname === '/') return pathname

    if (hasTrailingSlash) return pathname.slice(0, -1)

    return pathname
}
